var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchiveBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#DFFFF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#EBFFF9",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9325 38.75C20.5125 38.75 20.1225 38.65 19.7725 38.45C19.0025 38 18.5625 37.09 18.5625 35.96V21.86C18.5625 19.32 20.6325 17.25 23.1725 17.25H32.8225C35.3625 17.25 37.4325 19.32 37.4325 21.86V35.95C37.4325 37.08 36.9925 37.99 36.2225 38.44C35.4525 38.89 34.4425 38.84 33.4525 38.29L28.5725 35.58C28.2825 35.42 27.7125 35.42 27.4225 35.58L22.5425 38.29C22.0025 38.59 21.4525 38.75 20.9325 38.75ZM23.1825 18.75C21.4725 18.75 20.0725 20.15 20.0725 21.86V35.95C20.0725 36.54 20.2425 36.98 20.5425 37.15C20.8425 37.32 21.3125 37.27 21.8225 36.98L26.7025 34.27C27.4425 33.86 28.5625 33.86 29.3025 34.27L34.1825 36.98C34.6925 37.27 35.1625 37.33 35.4625 37.15C35.7625 36.97 35.9325 36.53 35.9325 35.95V21.86C35.9325 20.15 34.5325 18.75 32.8225 18.75H23.1825Z",
    fill: "#56BAA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0912 29.2499C26.9012 29.2499 26.7112 29.1799 26.5612 29.0299L25.0613 27.5299C24.7713 27.2399 24.7713 26.7599 25.0613 26.4699C25.3512 26.1799 25.8312 26.1799 26.1212 26.4699L27.0912 27.4399L30.5613 23.9699C30.8513 23.6799 31.3312 23.6799 31.6212 23.9699C31.9112 24.2599 31.9112 24.7399 31.6212 25.0299L27.6212 29.0299C27.4712 29.1799 27.2812 29.2499 27.0912 29.2499Z",
    fill: "#56BAA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveBanner);
export default __webpack_public_path__ + "static/media/archive-banner.e6b019708914c6f269cea8c497408525.svg";
export { ForwardRef as ReactComponent };